{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-7-bwr-bestandskonten-buchungssatz-eroeffnung",
  "version": "2026.08.1",
  "title": "BwR 7: Buchen auf Bestandskonten – Buchungssatz 'Soll an Haben' und Kontenabschluss (Realschule 7 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern BwR 7: Auflösung der Bilanz in Bestandskonten (Aktivkonten: AB/Zugänge im Soll, Passivkonten: AB/Zugänge im Haben), Buchungssatzregel 'Soll an Haben', EBK und SBK.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T23:10:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/7/bwr",
      "checked": "2026-08-15",
      "label": "Realschule BwR 7 (Wahlpflichtfächergruppe II), Lernbereich Buchen auf Bestandskonten"
    }
  ],
  "atoms": [
    {
      "id": "01K4W7K0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4W7K0000000000000000A01",
      "namespace": "bwr-buchfuehrung",
      "slug": "aufloesung-bilanz-aktiv-passivkonten-buchungsregeln",
      "title": "Bestandskonten: Struktur von Aktiv- und Passivkonten, Anfangsbestände und Zugänge/Abgänge",
      "domain": "schule/bwr/buchfuehrung",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q8134",
          "target_label": "Double-entry bookkeeping",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II",
          "subject": "bwr",
          "topic_code": "lb3",
          "topic_title": "Buchen auf Bestandskonten",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4W7K0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Auf welcher Kontoseite (Soll oder Haben) werden bei einem **Aktivkonto** (z. B. Fuhrpark, Bank, Kasse) der Anfangsbestand (AB) und sämtliche Zugänge (+) erfasst?",
          "concept": "Auf der linken Kontoseite, der Soll-Seite (Soll = links, Haben = rechts)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Auf der Soll-Seite (links)",
              "Auf der Haben-Seite (rechts)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4W7K0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre das System der doppelten Buchführung (Doppik) bei der Auflösung der Bilanz in T-Konten: 1. **Aktivkonten** (stehen auf der linken Bilanzseite Aktiva -> Anfangsbestand AB und Zugänge [+] im **Soll**, Abgänge [-] und Schlussbestand SB im **Haben**), 2. **Passivkonten** (stehen auf der rechten Bilanzseite Passiva -> Anfangsbestand AB und Zugänge [+] im **Haben**, Abgänge [-] und Schlussbestand SB im **Soll**), 3. Das Eröffnungsbilanzkonto (**EBK** als spiegelbildliches Gegenkonto) und das Schlussbilanzkonto (**SBK**).",
          "concept": "Doppik: Jede Buchung berührt mindestens 2 Konten; Aktivkonten: Soll = AB & Zugänge, Haben = Abgänge & SB; Passivkonten: Haben = AB & Zugänge, Soll = Abgänge & SB; EBK ist seitenverkehrt zur Eröffnungsbilanz (Aktiva im Haben, Passiva im Soll).",
          "sample_solution": "1. Die Auflösung der Bilanz in Bestandskonten: - Da nach jedem Geschäftsfall nicht die gesamte Bilanz neu gezeichnet werden kann, wird für jeden Bilanzposten ein separates **T-Konto (Bestandskonto)** eingerichtet. - Jedes T-Konto hat zwei Seiten: Die linke Seite heißt immer **Soll (S)**, die rechte Seite heißt immer **Haben (H)**. 2. Die Buchungsregeln für Aktiv- und Passivkonten: - **1. Aktivkonten (Vermögenskonten, z. B. Fuhrpark FP, Bauten, Bank BK, Kasse KA, Rohstoffe R)**:   * Entstehen aus den Positionen der linken Bilanzseite (Aktiva).   * **Soll (links)**: **Anfangsbestand (AB)** und alle **Zugänge (+)**   * **Haben (rechts)**: Alle **Abgänge (-)** und der **Schlussbestand (SB)**. - **2. Passivkonten (Kapital- und Schuldenkonten, z. B. Eigenkapital EK, Darlehen LBKV, Verbindlichkeiten VLL)**:   * Entstehen aus den Positionen der rechten Bilanzseite (Passiva).   * **Haben (rechts)**: **Anfangsbestand (AB)** und alle **Zugänge (+)**   * **Soll (links)**: Alle **Abgänge (-)** und der **Schlussbestand (SB)**. 3. Eröffnungsbilanzkonto (EBK) und Schlussbilanzkonto (SBK): - **Eröffnungsbilanzkonto (EBK)**:   * Dient als buchhalterisches Hilfs- und Gegenkonto zur Eröffnung der Bestandskonten zum 1. Januar.   * Da ein Buchungssatz immer 'Soll an Haben' lauten muss, ist das EBK **seitenverkehrt zur Eröffnungsbilanz** angelegt (Aktivbestände stehen im Haben des EBK, Passivbestände im Soll des EBK):     - *Aktivkonto an EBK [Betrag]*     - *EBK an Passivkonto [Betrag]*. - **Schlussbilanzkonto (SBK)**:   * Sammelt zum 31. Dezember alle Schlussbestände; entspricht in Form und Seiten exakt der Schlussbilanz:     - *SBK an Aktivkonto [SB]*     - *Passivkonto an SBK [SB]*."
        }
      ]
    },
    {
      "id": "01K4W7K0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4W7K0000000000000000A02",
      "namespace": "bwr-buchfuehrung",
      "slug": "buchungssatz-soll-an-haben-geschaeftsfaelle",
      "title": "Der Buchungssatz: Buchungsregel 'Soll an Haben', Kontenanalyse und Buchungspraxis",
      "domain": "schule/bwr/buchfuehrung",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4W7K0000000000000000A01",
          "type": "hard",
          "rationale": "Die Struktur von Aktiv- und Passivkonten ist Basis für die Formulierung von Buchungssätzen."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q8134",
          "target_label": "Journal entry",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II",
          "subject": "bwr",
          "topic_code": "lb3",
          "topic_title": "Buchen auf Bestandskonten",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4W7K0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie lautet die universelle Grundregel zur Formulierung jedes Buchungssatzes im betrieblichen Rechnungswesen?",
          "concept": "Sollkonto an Habenkonto [Betrag] (Immer das im Soll zu bebuchende Konto zuerst, gefolgt von 'an' und dem Habenkonto)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Soll an Haben [Betrag]",
              "Haben an Soll [Betrag]"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4W7K0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre den 4-stufigen Denkprozess zur Bildung eines fehlerfreien Buchungssatzes: 1. Welche Konten sind berührt?, 2. Handelt es sich um Aktiv- oder Passivkonten?, 3. Liegt ein Zugang (+) oder ein Abgang (-) vor?, 4. Muss im Soll oder im Haben gebucht werden? -> Buchungsregel **'Per [Sollkonto] an [Habenkonto] [Betrag]'** und bilde die Buchungssätze für folgende 3 Geschäftsfälle: a) Wir kaufen Büromöbel (BGA) für 4.200 € gegen Barzahlung, b) Ein Kunde begleicht unsere Ausgangsrechnung (Forderungen) über 8.500 € durch Banküberweisung, c) Wir kaufen Fertigungsmaterial (Rohstoffe) im Wert von 14.000 € auf Ziel (Lieferantenrechnung).",
          "concept": "4 Denkschritte: Konten -> Aktiv/Passiv -> +/- -> Soll/Haben; a) BGA (Aktiv, +, Soll) an Kasse (Aktiv, -, Haben) 4.200 €; b) Bank (Aktiv, +, Soll) an Forderungen (Aktiv, -, Haben) 8.500 €; c) Rohstoffe (Aktiv, +, Soll) an Verbindlichkeiten a. L.L. (Passiv, +, Haben) 14.000 €.",
          "sample_solution": "1. Das 4-Schritte-Schema zur Bildung von Buchungssätzen: - **Schritt 1**: Welche zwei (oder mehr) Konten werden durch den Beleg/Geschäftsfall berührt? - **Schritt 2**: Welcher Kontenart gehören sie an? (**Aktivkonto** für Vermögen oder **Passivkonto** für Kapital/Schulden?) - **Schritt 3**: Liegt auf dem jeweiligen Konto eine Zunahme (**Zugang [+]**) oder eine Abnahme (**Abgang [-]**) vor? - **Schritt 4**: Aus den Regeln ableiten: Wo wird gebucht (**Soll oder Haben**)?   * **Buchungssatz formulieren**:   $$\\mathbf{\\text{Sollkonto [Betrag] \\quad an \\quad Habenkonto [Betrag]}}$$ 2. Lösung der 3 Übungsfälle: - **a) Kauf von Büromöbeln (BGA) für 4.200 € bar**:   * 1. Konten: `BGA` (Betriebs- und Geschäftsausstattung) und `KA` (Kasse).   * 2. Kontenart: Beide sind **Aktivkonten**.   * 3. Veränderung: BGA nimmt zu (+4.200 €) $\\rightarrow$ **Soll**; Kasse nimmt ab (-4.200 €) $\\rightarrow$ **Haben**.   * **Buchungssatz**: **`BGA 4.200 € an KA 4.200 €`** (Aktivtausch). - **b) Kunde begleicht Rechnung über 8.500 € per Banküberweisung**:   * 1. Konten: `BK` (Bank) und `FO` (Forderungen aus Lieferungen und Leistungen).   * 2. Kontenart: Beide sind **Aktivkonten**.   * 3. Veränderung: Bank nimmt zu (+8.500 €) $\\rightarrow$ **Soll**; Forderungen nehmen ab (-8.500 €) $\\rightarrow$ **Haben**.   * **Buchungssatz**: **`BK 8.500 € an FO 8.500 €`** (Aktivtausch). - **c) Kauf von Rohstoffen für 14.000 € auf Ziel (Rechnung)**:   * 1. Konten: `R` (Rohstoffe) und `VLL` (Verbindlichkeiten aus Lieferungen und Leistungen).   * 2. Kontenart: `R` = **Aktivkonto**, `VLL` = **Passivkonto**.   * 3. Veränderung: Rohstoffe nehmen zu (+14.000 €) $\\rightarrow$ **Soll**; Verbindlichkeiten nehmen zu (+14.000 €) $\\rightarrow$ **Haben**.   * **Buchungssatz**: **`R 14.000 € an VLL 14.000 €`** (Aktiv-Passiv-Mehrung)."
        }
      ]
    }
  ]
}
